<!-- calculate new forecast version options -->
<button
  mat-menu-item
  data-testid="create-version-menu-button"
  [matMenuTriggerFor]="executeConfigurationOptions"
>
  <span class="inline-flex items-center">
    <pm-icon [icon]="RotateIcon" class="mr-2"></pm-icon>
    {{ 'RESULT_OVERVIEW.CREATE_VERSION' | translate }}
  </span>
</button>
<mat-menu #executeConfigurationOptions="matMenu" xPosition="after">
  <button
    mat-menu-item
    data-cy="re-calculation"
    data-testid="re-calculate-button"
    (click)="triggerRecalculation()"
  >
    {{ 'RESULT_OVERVIEW.RE_CALC' | translate }}
  </button>
  <button
    mat-menu-item
    data-testid="re-calculate-limited-data-button"
    (click)="triggerRecalculationWithLimitedData()"
  >
    {{ 'RESULT_OVERVIEW.RE_CALC_WITH_LIMITED_DATA' | translate }}
  </button>
  <button
    mat-menu-item
    data-testid="re-calculate-existing-model-button"
    (click)="triggerRecalculationWithExistingModel()"
  >
    {{ 'RESULT_OVERVIEW.RE_CALC_WITH_EXISTING_MODEL' | translate }}
  </button>
</mat-menu>
